// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  apiBaseUrl:'https://isn-notifation.herokuapp.com/',
  firebaseDB : {
  apiKey: "AIzaSyBd0Jq0q1wIbSeCtZAkMWApCkuA-W4xf5g",
  authDomain: "isnacademy-6866c.firebaseapp.com",
  projectId: "isnacademy-6866c",
  storageBucket: "isnacademy-6866c.appspot.com",
  messagingSenderId: "189738912739",
  appId: "1:189738912739:web:43a09e22cada62c79faed6"
}
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
